import React from 'react';

import { useChain } from 'contexts';
import { getChainData } from 'utils/chain';
import { ALL_CHAINS } from 'utils/constants';

const ChainButton: React.FC = () => {
  const { id: chainId, styleSlug, setChainId } = useChain();
  return (
    <div
      className={`hidden md:block rounded-full bg-${styleSlug}-light bg-gradient-to-l dark:from-${styleSlug}-light dark:to-${styleSlug}-primary`}
      style={{ padding: 2, height: 42 }}
    >
      <select
        className={`h-full rounded-full px-2 md:px-5 py-1 md:py-2 text-sm text-center bg-white dark:bg-gray-111 text-${styleSlug}-primary dark:text-${styleSlug}-light`}
        style={{ textAlignLast: 'center' }}
        value={chainId}
        onChange={(e) => setChainId(parseInt(e.target.value))}
      >
        {ALL_CHAINS.map((id) => {
          const { shortDisplayName } = getChainData(id);
          return (
            <option key={id} value={id}>
              {shortDisplayName}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default ChainButton;
